import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)
export const FORM_CONFIG = formConfig

// Minimal schema - no form fields needed, just confirmation
export const CancelProvisionFormSchema = z.object({})

export type CancelProvisionFormData = z.infer<typeof CancelProvisionFormSchema>

/**
 * Transforms form data to API request for cancelling provisioning
 *
 * @param deviceNumber - The device number
 * @param deviceProcurementInfoNumber - The procurement info number (optional for upsert)
 * @param deviceProvisioningInfoNumber - The provisioning info number (required for update)
 * @returns API request payload
 */
export function transformToApiRequest(
  deviceNumber: number,
  deviceProcurementInfoNumber?: number,
  deviceProvisioningInfoNumber?: number
) {
  return {
    procurementInfo: {
      deviceNumber,
      deviceProcurementInfoNumber,
      deviceProcurementStatus: 'received',
    },
    provisioningInfo: {
      deviceNumber,
      deviceProvisioningInfoNumber,
      // Backend enum is requested | success | failed | deprovisioned — there is no
      // 'cancelled'. Cancelling provisioning undoes it, so the status is 'deprovisioned'.
      deviceProvisioningStatus: 'deprovisioned',
    },
  }
}
